import * as amplify from "../util/amplify.ts";
import ApiServer from "../ApiServer.js";
import * as FwDatas from "../FwDatas.ts";
import * as modal from "../util/modal.ts";
import * as actionMenu from "../widget/action-menu.js"
import Icons from "../svg/Icons.ts"
import { protoExtend } from "../lib/ObjectUtil.js";
import { checkEventLimitOntry, modalEventHardLimitReached, modalOtherCircleEventHardLimitReached } from "./calendarclean.js";

function prepareEventInput(obj){
  var 
    event = obj.event,
    allDay = event.allDay,
    start = null,
    end = null,
    dbEvent = FwDatas.get(event.id);

  if(allDay){
    var rawStart = new Date(event.start)
    var rawEnd = new Date(event.end)
    if(event.end===null){
      rawEnd = new Date(rawStart)
      rawEnd.setDate(rawEnd.getDate()+1);
    }
    start = new Date(rawStart.getTime()-(60000*rawStart.getTimezoneOffset()));
    end = new Date(rawEnd.getTime()-(60000*rawEnd.getTimezoneOffset())-1000);

  }else{
    start = event.start;
    if(dbEvent.allDay){
      end = new Date(start)
      end.setHours(end.getHours()+1)
    }else{
      end = event.end||new Date(event.start.getTime()+dbEvent.endDate.getTime()-dbEvent.startDate.getTime());
    }
  }

  var eventInput = protoExtend(dbEvent);
  eventInput.metaId = event.id;
  eventInput.startDate = start;
  eventInput.endDate = end;
  eventInput.allDay = allDay;
  
  if(obj.oldResource || obj.newResource){
    if(obj.oldResource){
      //this != is on purpose, it might be string or number
      eventInput.attendeeIds = eventInput.attendeeIds.filter(id=>id!=obj.oldResource.id)
    }
    if(obj.newResource){
      eventInput.attendeeIds.push(obj.newResource.id)
    }
    eventInput.attendee = eventInput.attendeeIds.map(accountId=>{return {accountId}})
  }
  
  if(dbEvent.hasItsOwnRecurrency()){
    eventInput.recurrencyDescriptor = null;
  }
  eventInput.attendee = dbEvent.attendeeIds.map(accountId=>{return {accountId}})
  return eventInput;
}
export async function eventModified(obj){
  var 
    dbEvent = FwDatas.get(obj.event.id);
  
  if(dbEvent.metaId.indexOf('task/')===0){
    var result = new Date(dbEvent.dueDate);
    if(obj.delta){
      result.setDate(result.getDate() + obj.delta.days);
      result.setMonth(result.getMonth() + obj.delta.months);
      result.setFullYear(result.getFullYear() + obj.delta.years);
      result.setMilliseconds(result.getMilliseconds() + obj.delta.milliseconds);
      
      dbEvent.dueDate = result;
      ApiServer.taskupdate2(dbEvent)
    }
    amplify.publish('eventUpdated')
  }else if(!dbEvent.hasItsOwnRecurrency()){
    ApiServer.evtupdate(null,prepareEventInput(obj))
  }else{
    let eventInput = prepareEventInput(obj)
    var options = (await ApiServer.evtupdateoption(eventInput)).map(option=>{
      return {title:"event.updaterecurring"+option,onclick(){
        ApiServer.evtupdate(option,eventInput)
        amplify.publish('eventUpdated')
      }} 
    })
    if(options.length===1){
      options[0].onclick()
    }else{
      modal.ask({
        title:"actions.move",
        message:"event.moverecurringtext",
        button:options
      })
    }
    
  }
  
}
export async function copyEvent(obj){
  var 
    dbEvent = FwDatas.get(obj.event.id);
  
  
  if(dbEvent.metaId.indexOf('task/')===0){
    dbEvent.dueDate = obj.event.start;
    dbEvent.metaId = undefined;
    ApiServer.taskcreate2(dbEvent)
    amplify.publish('eventCreated')
  }else if(!dbEvent.hasItsOwnRecurrency()){
    let eventInput = prepareEventInput(obj)
    eventInput.metaId = undefined;
    if(!await checkEventLimitOntry(eventInput.familyId)){
      modalEventHardLimitReached(eventInput.familyId)
      amplify.publish('eventCreated') //to refresh fullcalendar
      return;
    }
    ApiServer.evtcreate.prepare({scope:eventInput.familyId})(eventInput)
    amplify.publish('eventCreated')
  }else{
    let eventInput = prepareEventInput(obj)
    eventInput.metaId = undefined;
    if(!await checkEventLimitOntry(eventInput.familyId)){
      modalEventHardLimitReached(eventInput.familyId)
      amplify.publish('eventCreated') //to refresh fullcalendar
      return;
    }
    modal.ask({
      title:"actions.copy",
      message:"event.copyrecurringtext",
      button:[
        {title:"event.updaterecurringOnlyOne",onclick(){
          eventInput.recurrencyDescriptor = new ApiServer.types.RecurrencyDescriptor({recurrency:'NONE'})
          ApiServer.evtcreate.prepare({scope:eventInput.familyId})(eventInput)
          amplify.publish('eventCreated')
        }},
        {title:"event.updaterecurringOnlyAfter",onclick(){
          ApiServer.evtcreate.prepare({scope:eventInput.familyId})(eventInput)
          amplify.publish('eventCreated')
        }}
        
      ]
    })
  }
  
}

export function eventDrop(obj){
  if(obj.oldResource){
    eventModified(obj)
    return;
  }

  document.body.insertAdjacentHTML('beforeend',`<div id="temp-container" style="position:fixed;left:0;right:0;top:0;bottom:0">
      <div id="mytag" style="position:absolute;left:${obj.jsEvent.pageX}px;top:${obj.jsEvent.pageY}px"></div>
    </div>`)
  function clean(){
    document.body.removeChild(document.getElementById('temp-container'))
  }
  var node = $("#mytag");
  actionMenu.init(node).open(obj.jsEvent,{
    menu:[
      {svg:Icons.ic_move, i18nkey:"actions.move",clickFunction:()=>{clean();eventModified(obj)}},
      {svg:Icons.ic_copy_one,i18nkey:"actions.copy",clickFunction:()=>{clean();copyEvent(obj)}}
    ],
    onCancel:()=>{
      clean();
      //TODO find good publish for just refreshing
      amplify.publish('eventCreated')
    }
  })
}